import React, { useRef, useState } from 'react'

import style from './LogicStatement.module.scss'
import { Tooltip } from 'primereact/tooltip'
import { Image as PrimeImage } from 'primereact/image'
import { IImageAsset } from '@aytm/app/swidget/base/modules/images/types'
import useSession from '../../../session/useSession'

export interface LogicRefProps {
  statement?: string
  text?: string
  value?: unknown
}

const LogicRef = React.memo<LogicRefProps>(
  ({ statement, value }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const logicClassId = useRef(`target${(Math.random() + 1).toString(36).slice(7)}`)
    const handleImageOnLoaded = () => {
      setIsLoaded(true)
    }

    const session = useSession()

    const image = value && (value as IImageAsset).original_url ? (value as IImageAsset) : null
    const text = image ? '' : (value as string)

    return (
      <span className={logicClassId.current} data-testid="SW-Question-LogicRef">
        {statement}
        {image && <img src={image.original_url} onLoad={handleImageOnLoaded} style={{ display: 'none' }} />}
        {(isLoaded || !image) && (
          <Tooltip
            target={`.${logicClassId.current}`}
            position="top"
            autoHide={false}
            appendTo={session.document?.body}
            className={`${style.tooltip} ${session.themeClassNames}`}
            data-testid="SW-Question-LogicRefTooltip"
          >
            {image && <PrimeImage src={image.original_url} className={style.image} />}
            {text ? <span dangerouslySetInnerHTML={{ __html: text }} /> : null}
            {'' === text && null == image ? 'empty' : null}
          </Tooltip>
        )}
      </span>
    )
  },
  (prevProps, nextProps) => prevProps.value === nextProps.value && prevProps.statement === nextProps.statement
)

LogicRef.displayName = 'LogicRef'

export default LogicRef
